const XIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="14" fill="#ef4444" fillOpacity="0.2" stroke="#ef4444" strokeWidth="2"/>
      <path 
        d="M11 11 L21 21 M21 11 L11 21" 
        stroke="#ef4444" 
        strokeWidth="3" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default XIcon;

